/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImageSchema
 */
export interface ImageSchema {
    /**
     * 
     */
    s3Key: string;
    /**
     * 
     */
    fileType: string | null;
    /**
     * 
     */
    url: string | null;
}

/**
 * Check if a given object implements the ImageSchema interface.
 */
export function instanceOfImageSchema(value: object): value is ImageSchema {
    if ((!('s3Key' in (value as Record<string, any>)) && !('s3_key' in (value as Record<string, any>))) || ((value as Record<string, any>)['s3Key'] === undefined && (value as Record<string, any>)['s3_key'] === undefined)) return false;
    if ((!('fileType' in (value as Record<string, any>)) && !('file_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['fileType'] === undefined && (value as Record<string, any>)['file_type'] === undefined)) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function ImageSchemaFromJSON(json: any): ImageSchema {
    return ImageSchemaFromJSONTyped(json, false);
}

export function ImageSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageSchema {
    if (json == null) {
        return json;
    }
    return {
        
        's3Key': json['s3_key'],
        'fileType': json['file_type'],
        'url': json['url'],
    };
}

export function ImageSchemaToJSON(json: any): ImageSchema {
    return ImageSchemaToJSONTyped(json, false);
}

export function ImageSchemaToJSONTyped(value?: ImageSchema | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        's3_key': value['s3Key'],
        'file_type': value['fileType'],
        'url': value['url'],
    };
}

